import { render, staticRenderFns } from "./WordsFieldReadingEnPreview.vue?vue&type=template&id=86b7f654&lang=pug&"
import script from "./WordsFieldReadingEnPreview.vue?vue&type=script&lang=js&"
export * from "./WordsFieldReadingEnPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports